import React from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { logError } from "../Features/Errors/Actions/ErrorActions";

import ErrorLogo from "../assets/error/alert.png";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  // Update state so the next render will display the fallback UI
  static getDerivedStateFromError(error) {
    console.log(error);
    return { hasError: true, error };
  }

  // Log the error to the console and to an error reporting endpoint
  componentDidCatch(error, errorInfo) {
    console.log(error);
    console.log(errorInfo);
    this.setState({
      error,
      errorInfo,
    });
    logError(error, errorInfo);
  }

  refreshPage() {
    window.location.reload(false);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="box position-absolute top-50 start-50 translate-middle d-flex align-items-center flex-column p-5">
          <div>
            <h1 className="fs-3 fw-bold">An error has occurred</h1>
            <h2 className="fs-5 text-muted">Please inform an invigilator</h2>
          </div>
          <img
            src={ErrorLogo}
            style={{ width: "128px" }}
            alt="Web error icon"
            className="my-1"
          />

          <div className="d-flex flex-column mt-4">
            <Form.Text>
              Reload the page?
              <Link
                className="mx-2 text-decoration-none link-font-size"
                onClick={this.refreshPage}
              >
                Refresh ↻
              </Link>
            </Form.Text>
            <Form.Text>
              Back to the sign in page?
              <Link
                className="mx-2 text-decoration-none link-font-size"
                to="/login"
              >
                Candidate Sign In
              </Link>
            </Form.Text>
          </div>
          <div className="flex flex-col justify-start mt-2 w-full">
            {this.state.errorInfo && (
              <details style={{ whiteSpace: "pre-wrap" }}>
                <summary>Error details</summary>
                {this.state.errorInfo.componentStack}
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
